import React from "react";
import { Link } from "@backstage/core-components";
import {
  Divider,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
} from "@material-ui/core";
import { useAnalytics } from "@backstage/core-plugin-api";
import { ResultHighlight } from "@backstage/plugin-search-common";
import { HighlightedSearchResultText } from "@backstage/plugin-search-react";

type EnvVarSearchResultListItemProps = {
  result: any;
  icon?: React.ReactNode;
  rank?: number;
  highlight?: ResultHighlight;
};

export const EnvVarSearchResultListItem = (
  props: EnvVarSearchResultListItemProps
) => {
  const { location, title, text } = props.result;
  const { highlight } = props;
  const analytics = useAnalytics();

  const handleClick = () => {
    analytics.captureEvent("discover", title, {
      attributes: { to: location },
      value: props.rank,
    });
  };

  return (
    <>
      <ListItem alignItems="center">
        {props.icon && <ListItemIcon>{props.icon}</ListItemIcon>}
        <Box flexWrap="wrap">
          <ListItemText
            primaryTypographyProps={{ variant: "h6" }}
            primary={
              <Link to={location} noTrack onClick={handleClick}>
                {highlight?.fields?.title ? (
                  <HighlightedSearchResultText
                    text={highlight.fields.title}
                    preTag={highlight.preTag}
                    postTag={highlight.postTag}
                  />
                ) : (
                  title
                )}
              </Link>
            }
            secondary={
              highlight?.fields?.text ? (
                <>
                  <HighlightedSearchResultText
                    text={highlight.fields.text}
                    preTag={highlight.preTag}
                    postTag={highlight.postTag}
                  />
                </>
              ) : (
                text
              )
            }
          />
        </Box>
      </ListItem>
      <Divider />
    </>
  );
};
